//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { IGallery } from '@apis/galleries/galleriesApiModels';
import { ICuralateStore } from '@models/AppState';
import { Normalized } from '@utils/normalize';

const getGalleries = (state: ICuralateStore) => state.galleries.data.galleries;
const getSelectedGalleryId = (state: ICuralateStore) =>
  state.galleries.picker.selectedGalleryId;

export const getSelectedGallery = createSelector(
  getGalleries,
  getSelectedGalleryId,
  (galleries, selectedGalleryId): IGallery | undefined =>
    Normalized.getById(galleries, selectedGalleryId),
);

export default getSelectedGallery;
